import React, { FC, useCallback, useState } from 'react';
import { UseFormMethods } from 'react-hook-form/dist/types/form';
import { useDispatch, useSelector } from 'react-redux';
import { FormGroup, Switch, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../reducers';
import SettingsGroupTitle from '../../SettingsGroupTitle/SettingsGroupTitle';
import './SEIntegration.scss';
import FormSwitch from '../../Form/FormSwitch/FormSwitch';
import FormInput from '../../Form/FormInput/FormInput';
import { sendDaSubscribedState } from '../../../reducers/Subscription/Subscription';
import SELoginButton from '../SELoginButton/SELoginButton';

interface SEIntegration {
  control: UseFormMethods['control'];
}

const SEIntegration: FC<SEIntegration> = ({ control }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { hasSEAuth } = useSelector((root: RootState) => root.user);
  const {
    se: { actual, loading },
  } = useSelector((root: RootState) => root.subscription);
  const [isSubscribed, setIsSubscribed] = useState<boolean>(actual);

  const handleSwitchChange = useCallback(
    (e: any, checked: boolean): void => {
      setIsSubscribed(checked);
      dispatch(sendDaSubscribedState(checked));
    },
    [dispatch],
  );

  return (
    <>
      <SettingsGroupTitle title="StreamElements">
        <Switch onChange={handleSwitchChange} disabled={loading} checked={isSubscribed} />
      </SettingsGroupTitle>
      {isSubscribed ? (
        <FormGroup>
          <FormGroup row className="auc-settings-row">
            <FormInput
              name="se.pointsRate"
              control={control}
              label={t('settings.donations.pointsRate')}
              type="number"
              className="field md"
            />
          </FormGroup>
          <FormGroup row className="auc-settings-row">
            <FormSwitch
              name="se.isIncrementActive"
              control={control}
              label={t('settings.donations.addTimeOnDonation')}
            />
            <FormInput name="se.incrementTime" className="field sm" control={control} type="number" />
            <Typography variant="body1">{t('common.sec')}</Typography>
          </FormGroup>
        </FormGroup>
      ) : (
        <SELoginButton />
      )}
    </>
  );
};

export default SEIntegration;
